import { combineReducers } from "redux";
// import ChatApp from './chat.reducer';
// import TodoApp from './todo.reducer';
import auth from "./auth";
import alert from "./alert";
import application from "./application";

const reducers = combineReducers({
  auth,
  alert,
  application
  // TodoApp,
  // ChatApp
});

export default reducers;
